import { Card, CardContent, CardHeader, CardTitle } from "@shadcn-in-nx/ui/card";
import { Button } from "@shadcn-in-nx/ui/button";
import { Loader2, ChevronLeft, ChevronRight } from "lucide-react";
import ErrorRow from "./ErrorRow";

export function ErrorList({ errors, isLoading, t }) {
    if (isLoading && !errors.length) {
        return (
            <div className="flex justify-center py-12">
                <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
            </div>
        );
    }
    return (
        <div className="space-y-2">
            {errors.map((err) => (
                <ErrorRow key={`${err.pk}-${err.sk}`} error={err} />
            ))}
            {errors.length === 0 && (
                <p className="text-center text-muted-foreground py-8">
                    {t("admin.intelligence.errors.noErrors")}
                </p>
            )}
        </div>
    );
}

export function Pagination({ page, totalPages, total, setPage, t }) {
    if (totalPages <= 1) return null;
    return (
        <div className="flex items-center justify-between pt-2">
            <span className="text-sm text-muted-foreground">
                {t("admin.intelligence.errors.showing", { total })}
            </span>
            <div className="flex items-center gap-2">
                <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => setPage(page - 1)}>
                    <ChevronLeft className="h-4 w-4" />
                </Button>
                <span className="text-sm">{page} / {totalPages}</span>
                <Button size="sm" variant="outline" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>
                    <ChevronRight className="h-4 w-4" />
                </Button>
            </div>
        </div>
    );
}

export function StatCard({ label, value, active, highlight, onClick }) {
    const base = onClick ? "cursor-pointer hover:border-primary transition-colors" : "";
    const activeClass = active ? "border-primary bg-primary/5" : "";
    const highlightClass = highlight && !active ? "border-orange-400 bg-orange-50 dark:bg-orange-950/20" : "";
    return (
        <Card className={`${base} ${activeClass} ${highlightClass}`} onClick={onClick}>
            <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-muted-foreground">{label}</CardTitle>
            </CardHeader>
            <CardContent>
                <p className="text-2xl font-bold">{value}</p>
            </CardContent>
        </Card>
    );
}
